import type { PropsWithChildren } from "react";

export function Skeleton({ className, children }: PropsWithChildren<{ className?: string }>) {
  return (
    <div className={`${className} bg-mercury dark:bg-bright-gray lg:rounded-4 animate-pulse`}>
      {children}
    </div>
  );
}
